import React from 'react';
import { connect } from 'react-redux';
import reduxForm from 'redux-form/lib/reduxForm';
import CreateAccount from '../CreateAccount';
import {
  submitCreateAccountForm,
  showLogin,
  validate,
  showRequestResetPassword,
} from '../../user';
import { ONBOARDING_VANITY_URL_FORM } from '../../onboarding';

const CREATE_ACCOUNT_FORM = 'createAccount';

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(submitCreateAccountForm(data)),
  clickLogIn: () => dispatch(showLogin('Log In')),
  onClickRequestResetPassword: () =>
    dispatch(showRequestResetPassword('Forgot Password')),
});

const mapStateToProps = ({ routing, form }, { feedUrl }) => ({
  routing,
  feedUrl,
  enableReinitialize: true,
  initialValues: getInitialValuesFromForm(form),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'createAccount',
    validate,
  })(CreateAccount)
);

function getVanitySlugFromForm(form) {
  const onboardingForm = form[ONBOARDING_VANITY_URL_FORM];
  if (onboardingForm.values && onboardingForm.values.vanitySlug) {
    return onboardingForm.values.vanitySlug;
  }
  return null;
}

// Restores any current values in the form (otherwise they get cleared), but also populates vanity slug if it has changed from a related form (e.g. onboarding)
function getInitialValuesFromForm(form) {
  const createAccountForm = form[CREATE_ACCOUNT_FORM];
  if (!createAccountForm || !createAccountForm.values) {
    return {};
  }
  return {
    ...createAccountForm.values,
    vanitySlug: getVanitySlugFromForm(form),
  };
}
